import { useQuery } from 'react-query';
import API from '../api/phx';

const fetchSettings = async () => {
  const res = await API.get(`/cart/hotel_minicart_info`);
  return res.data;
};

export const useHotelInfo = () => {
  return useQuery(['hotelInfo'], fetchSettings);
};


export default useHotelInfo;